export default {
    company_agency: "Loja",
    document: "CI",
    no_company_agency_found: "Nenhuma loja encontrada",
    project_name: "Academia Inca",
}